import { defineComponent as t, createBlock as o, openBlock as a, resolveDynamicComponent as n, mergeProps as s, unref as l, withCtx as p, renderSlot as b } from "vue";
import { useBindCx as d } from "@scalar/components";
const f = /* @__PURE__ */ t({
  inheritAttrs: !1,
  __name: "DataTableCell",
  props: {
    is: { default: "td" }
  },
  setup(i) {
    const { cx: r } = d();
    return (e, m) => (a(), o(n(e.is), s(
      l(r)(
        "box-content max-h-8 min-h-8 min-w-8 border-l-0 border-t border-b-0 border-r flex text-base last:border-r-0 group-last:border-b-transparent p-0 m-0 relative"
      ),
      { class: "group-[.alert]:bg-b-alert group-[.error]:bg-b-danger" }
    ), {
      default: p(() => [
        b(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
